<div class="pet-panel">
  <!-- Name block-->
  @if (pet) {
    <div class="pet-panel__fixed-title">
      <div class="pet-panel__pet-name-container">
        @if (pet?.speciesCode) {
          <img alt="" class="pet-panel__pet-name-container-picture" src="assets/other/placeholder_{{ pet?.speciesCode }}.svg" />
        }
        <p class="pet-panel__pet-name-container-name">{{ pet?.name }}</p>
      </div>
      <div class="divider-without-margin"></div>
    </div>
  }

  <div class="pet-panel__scroll-container">
    <!-- Action edit pet details block-->
    <div class="pet-panel__action-details-container">
      <rc-link
        data-qa="vs-display-profile-sidebar-pet-details-button-edit"
        variant="secondary"
        size="large"
        iconname="edit"
        iconposition="left"
        [disabled]="!isEditing?.petDetails"
        (click)="editPetDetails(PanelSection.PetDetails)"
      >
        {{ 'path_pet-details' | translateKey }}
      </rc-link>
      <span class="arrow-down" [class.reversed]="isPanelPetDetailsExpended" (click)="showPanelDetails(PanelSection.PetDetails)"
        ><app-icon [name]="IconName.chevron_down"></app-icon
      ></span>
    </div>
    <div class="divider-without-margin"></div>
    <div class="details-form-expended" [class.details-form-retracted]="!isPanelPetDetailsExpended">
      <app-rc-list [highlightValue]="true" [listItems]="petDetailsFields"></app-rc-list>
      <div class="divider-without-margin"></div>
    </div>

    <!-- Action edit pet weight block-->
    <div class="pet-panel__action-details-container">
      <rc-link
        data-qa="vs-display-profile-sidebar-weight-button-edit"
        variant="secondary"
        size="large"
        iconname="edit"
        iconposition="left"
        [disabled]="!isEditing?.petWeight"
        (click)="editPetDetails(PanelSection.PetWeight)"
      >
        {{ 'label_weight-activity-level' | translateKey }}
      </rc-link>
      <span class="arrow-down" [class.reversed]="isPanelPetWeightExpended" (click)="showPanelDetails(PanelSection.PetWeight)"
        ><app-icon [name]="IconName.chevron_down"></app-icon
      ></span>
    </div>
    <div class="divider-without-margin"></div>
    <div class="details-form-expended" [class.details-form-retracted]="!isPanelPetWeightExpended">
      <app-rc-list [highlightValue]="true" [listItems]="petWeightFields"></app-rc-list>
      <div class="divider-without-margin"></div>
    </div>

    <!-- Display growth chart -->
    @if (displayGrowthChart) {
      <div class="pet-panel__action-details-container">
        <rc-link
          data-qa="vs-display-profile-sidebar-chart-button-view"
          variant="secondary"
          size="large"
          iconname="view-show"
          iconposition="left"
          (click)="editGrowthChart(PanelSection.PetGrowthChart)"
        >
          {{ 'label_side-panel-growth-chart' | translateKey }}
        </rc-link>
      </div>
      <div class="divider-without-margin"></div>
    }

    @if (displayDiagnosis) {
      <!-- Action edit pet diagnosis block-->
      <div class="pet-panel__action-details-container">
        <rc-link
          data-qa="vs-display-profile-sidebar-pathologies-button-edit"
          variant="secondary"
          size="large"
          iconname="edit"
          iconposition="left"
          [disabled]="!isEditing?.petDiagnosis"
          (click)="editPetDetails(PanelSection.PetDiagnosis)"
        >
          {{ 'path_diagnosis' | translateKey }}
        </rc-link>
        @if (pet?.pathologies?.length || pet?.sensitivities?.length) {
          <span class="arrow-down" [class.reversed]="isPanelPetDiagnosisExpended" (click)="showPanelDetails(PanelSection.PetDiagnosis)"
            ><app-icon [name]="IconName.chevron_down"></app-icon
          ></span>
        }
      </div>
      <div class="divider-without-margin"></div>
      <div class="pet-panel__disease-container details-form-expended" ngif [class.details-form-retracted]="!isPanelPetDiagnosisExpended">
        @if (pet?.pathologies?.length) {
          <p class="pet-panel__disease-container-title" i18n="@@title_pathologies">Pathologies</p>
          <div class="pet-panel__disease-container-tag">
            @for (selectedItem of pet?.pathologies; track selectedItem) {
              <rc-tag class="pet-panel__tag" [size]="RCTagSize.XS" [text]="'pathology-' + selectedItem | translateKey"></rc-tag>
            }
          </div>
        }
        @if (pet?.sensitivities?.length) {
          <p class="pet-panel__disease-container-title" i18n="@@title_sensitivities">Other conditions</p>
          <div class="pet-panel__disease-container-tag">
            @for (selectedItem of pet?.sensitivities; track selectedItem) {
              <rc-tag class="pet-panel__tag" [size]="RCTagSize.XS" [text]="'sensitivity-' + selectedItem | translateKey"></rc-tag>
            }
          </div>
        }
      </div>
      <div class="divider-without-margin"></div>
    }

    <!-- Action go to nutritional assessment-->
    @if (displayXrayLink) {
      <div class="pet-panel__action-details-container">
        <rc-link
          data-qa="vs-display-profile-sidebar-nutritional-button-view"
          variant="secondary"
          size="large"
          iconname="arrow-go"
          iconposition="left"
          [disabled]="!isEditing?.petWeight"
          (click)="editPetDetails(PanelSection.PetNutritionalAssessment)"
        >
          {{ 'sr-xray_block_title' | translateKey }}
        </rc-link>
      </div>
    }
  </div>
</div>
